import * as types from "./types";
import _ from 'lodash';

export const defaultState = {   
  notifications: []  
};

const ui_notifications = (state = defaultState, action) => {
  switch (action.type) {     
    case types.PUSH_NOTIFICATION:      
      return {
        notifications: [...state.notifications, action.notification]               
      }     
    case types.REMOVE_NOTIFICATION:
      let notifications = _.without(state.notifications, action.notification)      
      return {
        notifications: notifications                    
      }
    default:
      return state;
  }
};
export default ui_notifications;
